<template>
  <div>
    <b-row>
      <b-col cols="12">
        <div class="d-flex justify-content-between">
          <h2 class="mb-2">{{ $t("reception.patient-detalis") }}</h2>
        </div>
      </b-col>
      <b-col class="w-50">
        <b-link :to="{ name: 'Reception-Departments' }">
          <statistic-card-horizontal
            icon=""
            :statistic="$t('common.go-back')"
            class="modify"
          />
        </b-link>
      </b-col>
      <b-col class="w-50" v-if="patientCardDetails">
        <b-link
          :to="{ name: 'active-patient-card', params: { id: patientData.id,is_active: true, card_id: patientCardDetails.id } }"
          v-if="this.$store.state.app.permissions.includes('show-patientCard')"
        >
          <statistic-card-horizontal
            icon=""
            :statistic="$t('reception.see-active-card')"
            class="modify"
          />
        </b-link>
      </b-col>
    </b-row>
    <b-row>
      <!-- Col: Left (Invoice Container) -->
      <b-col cols="12" sm="12" md="8" lg="9" xl="9">
        <template v-if="patientLoading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <b-row>
          <!-- Header -->
          <!-- Patient Basic Info Card -->
          <b-col cols="12" md="4">
            <b-card
              style="min-height: 320px"
              class="text-center d-flex flex-column align-items-center"
            >
              <div class="text-center">
                <!-- Gender Icon -->
                <feather-icon
                  :icon="
                    patientData.gender === 'Male' ? 'UserIcon' : 'UserIcon'
                  "
                  :size="patientData.gender === 'Male' ? '70' : '50'"
                  :style="{
                    color:
                      patientData.gender === 'Male' ? '#0d6efd' : '#dc3545',
                  }"
                />
              </div>

              <!-- Name -->
              <h2 class="my-2">{{ patientData.name }}</h2>

              <!-- Gender, Birth Date, Phone -->
              <div class="text-start">
                <h5 class="my-2">
                  <b>{{ $t("reception.gender") }}:</b>
                  <span class="mx-2">{{ patientData.gender }}</span>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.birth-date") }}:</b>
                  <span class="mx-2">{{ patientData.birth_date }}</span>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.phone") }}:</b>
                  <span
                    class="mx-2"
                    style="unicode-bidi: isolate"
                    :style="{
                      direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr',
                    }"
                    >{{ patientData.phone }}</span
                  >
                </h5>
                <h5
                  class="my-2"
                  v-if="
                    patientCardDetails &&
                    patientCardDetails.surgeries &&
                    patientCardDetails.surgeries.length > 0
                  "
                >
                  <b>{{ $t("common.current-surgery") }}:</b>
                  <span class="mx-2">{{
                    patientCardDetails.surgeries
                      ? patientCardDetails.surgeries[
                          patientCardDetails.surgeries.length - 1
                        ].surgery.title
                      : ""
                  }}</span>
                </h5>
              </div>
            </b-card>
          </b-col>

          <!-- Additional Info Card 1 -->
          <b-col cols="12" md="8">
            <b-card style="min-height: 320px">
              <b-row>
                <b-col>
                  <h5 class="my-2">
                    <b>{{ $t("reception.patient-mother-name") }}:</b>
                    <span class="mx-2">{{ patientData.mother_name }}</span>
                  </h5>
                  <h5 class="my-2">
                    <b>{{ $t("reception.occupation") }}:</b>
                    <span class="mx-2">{{ patientData.occupation }}</span>
                  </h5>
                  <h5 class="my-2">
                    <b>{{ $t("reception.martial-status") }}:</b>
                    <span class="mx-2">{{ patientData.marital_status }}</span>
                  </h5>
                  <h5 class="my-2">
                    <b>{{ $t("reception.educational-level") }}:</b>
                    <span class="mx-2">{{ patientData.education_level }}</span>
                  </h5>
                </b-col>

                <b-col>
                  <h5 class="my-2">
                    <b>{{ $t("reception.residence-type") }}:</b>
                    <span class="mx-2">{{ patientData.residence_type }}</span>
                  </h5>
                  <h5 class="my-2">
                    <b>{{ $t("reception.city-name") }}:</b>
                    <span class="mx-2">{{ patientData.city_name }}</span>
                  </h5>
                  <h5 class="my-2">
                    <b>{{ $t("reception.district-name") }}:</b>
                    <span class="mx-2">{{ patientData.district_name }}</span>
                  </h5>
                  <h5 class="my-2">
                    <b>{{ $t("reception.judiciary-name") }}</b>
                    <span class="mx-2">{{ patientData.judiciary_name }}</span>
                  </h5>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="12">
            <b-card>
              <b-row>
                <!-- Additional Info Card 3 -->
                <b-col cols="12" md="4">
                  <b-card>
                    <h5 class="my-2">
                      <b>{{ $t("reception.township") }}:</b>
                      <span class="mx-2">{{ patientData.town_name }}</span>
                    </h5>
                    <h5 class="my-2">
                      <b>{{ $t("reception.street-name") }}:</b>
                      <span class="mx-2">{{ patientData.street_name }}</span>
                    </h5>
                    <h5 class="my-2">
                      <b>{{ $t("reception.building-number") }}:</b>
                      <span class="mx-2">{{
                        patientData.building_number
                      }}</span>
                    </h5>
                    <h5 class="my-2">
                      <b>{{ $t("reception.national-id") }}:</b>
                      <span class="mx-2">{{ patientData.national_id }}</span>
                    </h5>
                  </b-card>
                </b-col>

                <!-- Additional Info Card 4 -->
                <b-col cols="12" md="4">
                  <b-card>
                    <h5 class="my-2">
                      <b>{{ $t("reception.document-number") }}:</b>
                      <span
                        class="mx-2"
                        style="unicode-bidi: isolate"
                        :style="{
                          direction: $store.state.appConfig.isRTL
                            ? 'rtl'
                            : 'ltr',
                        }"
                        >{{ patientData.document_number }}</span
                      >
                    </h5>
                    <h5 class="my-2">
                      <b>{{ $t("reception.paper-number") }}:</b>
                      <span
                        class="mx-2"
                        style="unicode-bidi: isolate"
                        :style="{
                          direction: $store.state.appConfig.isRTL
                            ? 'rtl'
                            : 'ltr',
                        }"
                        >{{ patientData.document_page_number }}</span
                      >
                    </h5>
                    <h5 class="my-2">
                      <b>{{ $t("reception.dpcs") }}:</b>
                      <span class="mx-2">{{
                        patientData.department_of_civil_status
                      }}</span>
                    </h5>
                    <h5 class="my-2">
                      <b>{{ $t("reception.patient-no") }}:</b>
                      <span
                        class="mx-2"
                        style="unicode-bidi: isolate"
                        :style="{
                          direction: $store.state.appConfig.isRTL
                            ? 'rtl'
                            : 'ltr',
                        }"
                        >{{ patientData.patient_no }}</span
                      >
                    </h5>
                    <h5 class="my-2">
                      <b>{{ $t("reception.VisitـHospitalـNumber") }}:</b>
                      <span
                        class="mx-2"
                        style="unicode-bidi: isolate"
                        :style="{
                          direction: $store.state.appConfig.isRTL
                            ? 'rtl'
                            : 'ltr',
                        }"
                        >{{
                          patientData.number_of_total_stays_in_hospital
                        }}</span
                      >
                    </h5>
                  </b-card>
                </b-col>

                <!-- Patient Updates Card -->
                <b-col cols="12" md="4">
                  <b-card>
                    <h5 class="my-2">
                      <b>{{ $t("reception.date-of-last-update") }}:</b>
                      <span
                        class="mx-2"
                        style="unicode-bidi: isolate"
                        :style="{
                          direction: $store.state.appConfig.isRTL
                            ? 'rtl'
                            : 'ltr',
                        }"
                        >{{ patientData.updated_at }}</span
                      >
                    </h5>
                    <h5 class="my-2">
                      <b>{{ $t("reception.patient-info-created-at") }}:</b>
                      <span
                        class="mx-2"
                        style="unicode-bidi: isolate"
                        :style="{
                          direction: $store.state.appConfig.isRTL
                            ? 'rtl'
                            : 'ltr',
                        }"
                        >{{ patientData.created_at }}</span
                      >
                    </h5>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" sm="12" md="4" lg="3" xl="3" class="invoice-actions">
        <AddNewPatientCard
          @refreshPatientCard="getPatientCard"
          :patientCard="patientCardDetails"
          :surgeries="patientCardDetails.surgeries"
        />

       </b-col>
    </b-row>

    <!-- pulse table -->

    <!-- end of pulse table -->
    <!-- start of opertaive notes table -->

    <!-- end of operative notes table -->
    <!-- Agreement Form -->

    <!-- End of Agreement -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2PdfTimeDate"
    >
      <section dir="rtl" class="pdf-content font-modify m-5" slot="pdf-content">
        <h1 class="text-center">{{ $brand.nameArFull }}</h1>
        <h5 class="mt-2">:Patient Name</h5>
        <table style="width: 100%; table-layout: fixed">
          <tr>
            <th>Night Tour</th>
            <th>Morning Tour</th>
          </tr>
          <tr>
            <th>Date 1/1/24 Time: 12:0</th>
            <th>Date 1/1/24 Time 12:0</th>
          </tr>
          <tr>
            <td style="height: 80px"></td>
            <td style="height: 80px"></td>
          </tr>
          <tr>
            <th>Date 1/1/24 Time: 12:0</th>
            <th>Date 1/1/24 Time 12:0</th>
          </tr>
          <tr>
            <td style="height: 80px"></td>
            <td style="height: 80px"></td>
          </tr>
          <tr>
            <th>Date 1/1/24 Time: 12:0</th>
            <th>Date 1/1/24 Time 12:0</th>
          </tr>
          <tr>
            <td style="height: 80px"></td>
            <td style="height: 80px"></td>
          </tr>
          <tr>
            <th>Date 1/1/24 Time: 12:0</th>
            <th>Date 1/1/24 Time 12:0</th>
          </tr>
          <tr>
            <td style="height: 80px"></td>
            <td style="height: 80px"></td>
          </tr>
          <tr>
            <th>Date 1/1/24 Time: 12:0</th>
            <th>Date 1/1/24 Time 12:0</th>
          </tr>
          <tr>
            <td style="height: 80px"></td>
            <td style="height: 80px"></td>
          </tr>
        </table>
      </section>
    </vue-html2pdf>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2Pdf"
    >
      <section class="pdf-content font-modify" slot="pdf-content">
        <div class="modalDiv modalPrint mx-5 mt-5">
          <h2 dir="rtl" class="text-center">{{ $brand.nameArFull }}</h2>
          <h4 class="text-center mt-1">Doctor's Notes</h4>
          <table class="mt-1" border="1">
            <tr>
              <th style="height: 30px" colspan="2">Patient Name</th>
              <th style="height: 30px" colspan="3"></th>
            </tr>
            <tbody>
              <tr>
                <th style="width: 80px; height: 30px">Date</th>
                <th style="width: 80px; height: 30px">Time</th>
                <th style="width: 70%; height: 30px">Notes and orders</th>
              </tr>
              <tr>
                <td style="width: 80px; height: 30px"></td>
                <td style="width: 80px; height: 30px"></td>
                <td style="height: 30px"></td>
              </tr>
              <tr>
                <td style="width: 80px; height: 30px"></td>
                <td style="width: 80px; height: 30px"></td>
                <td style="height: 30px"></td>
              </tr>
              <tr>
                <td style="width: 80px; height: 30px"></td>
                <td style="width: 80px; height: 30px"></td>
                <td style="height: 30px"></td>
              </tr>
              <tr>
                <td style="width: 80px; height: 30px"></td>
                <td style="width: 80px; height: 30px"></td>
                <td style="height: 30px"></td>
              </tr>
              <tr>
                <td style="width: 80px; height: 30px"></td>
                <td style="width: 80px; height: 30px"></td>
                <td style="height: 30px"></td>
              </tr>
              <tr>
                <td style="width: 80px; height: 30px"></td>
                <td style="width: 80px; height: 30px"></td>
                <td style="height: 30px"></td>
              </tr>
              <tr>
                <td style="width: 80px; height: 30px"></td>
                <td style="width: 80px; height: 30px"></td>
                <td style="height: 30px"></td>
              </tr>
              <tr>
                <td style="width: 80px; height: 30px"></td>
                <td style="width: 80px; height: 30px"></td>
                <td style="height: 30px"></td>
              </tr>
              <tr>
                <td style="width: 80px; height: 30px"></td>
                <td style="width: 80px; height: 30px"></td>
                <td style="height: 30px"></td>
              </tr>
              <tr>
                <td style="width: 80px; height: 30px"></td>
                <td style="width: 80px; height: 30px"></td>
                <td style="height: 30px"></td>
              </tr>
              <tr>
                <td style="width: 80px; height: 30px"></td>
                <td style="width: 80px; height: 30px"></td>
                <td style="height: 30px"></td>
              </tr>
              <tr>
                <td style="width: 80px; height: 30px"></td>
                <td style="width: 80px; height: 30px"></td>
                <td style="height: 30px"></td>
              </tr>
              <tr>
                <td style="width: 80px; height: 30px"></td>
                <td style="width: 80px; height: 30px"></td>
                <td style="height: 30px"></td>
              </tr>
              <tr>
                <td style="width: 80px; height: 30px"></td>
                <td style="width: 80px; height: 30px"></td>
                <td style="height: 30px"></td>
              </tr>
              <tr>
                <td style="width: 80px; height: 30px"></td>
                <td style="width: 80px; height: 30px"></td>
                <td style="height: 30px"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </vue-html2pdf>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2PdfNurse"
    >
      <section class="pdf-content font-modify" slot="pdf-content">
        <div class="modalDiv modalPrint mx-5 mt-5">
          <h2 dir="rtl" class="text-center">{{ $brand.nameArFull }}</h2>
          <h6 class="text-center mt-1">Nursing Notes</h6>
          <table class="border border-0 mt-2">
            <tr>
              <th style="width: 60px" scope="col">العلاج</th>

              <th scope="col">الوقت</th>
              <th scope="col">التاريخ</th>
              <th style="width: 60px" scope="col">العلاج</th>

              <th scope="col">الوقت</th>
              <th scope="col">التاريخ</th>
            </tr>
            <tbody>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
              <tr>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
                <td style="height: 20px"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import { BCard, BRow, BCol, BButton, BLink, BSpinner } from "bootstrap-vue";
import router from "@/router";
import ReceptionHistoryCard from "@/components/reception/ReceptionHistoryCard";
import ReceptionPatientCardWithQR from "@/components/reception/ReceptionPatientCardWithQR";
import VueHtml2pdf from "vue-html2pdf";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import AddNewPatientCard from "./AddNewPatientCard.vue";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCard,
    BButton,
    ReceptionHistoryCard,
    ReceptionPatientCardWithQR,
    VueHtml2pdf,
    StatisticCardHorizontal,
    AddNewPatientCard,
    BSpinner,
  },

  data() {
    return {
      patientData: {},
      patientCardDetails: {},
      loading: false,
      patientLoading: false,
    };
  },
  mounted() {
    this.getPatientInfo();
  },

  methods: {
    async getPatientInfo() {
      this.patientLoading = true;
      await this.getPatient(`/patient/${router.currentRoute.params.id}`);
      this.loading = false;
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.patientData = this.all_data;
      this.patientLoading = false;

      this.getPatientCard();
    },

    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    generateMedsReport() {
      this.$refs.html2PdfMeds.generatePdf();
    },

    generateExaminationTable() {
      this.$refs.html2PdfExaminationTable.generatePdf();
    },
    generateOperativeNotes() {
      this.$refs.html2PdfOpeartiveTable.generatePdf();
    },
    generateTimeDatePdf() {
      this.$refs.html2PdfTimeDate.generatePdf();
    },
    testGenerate() {
      this.$refs.html2PdfAll.generatePdf();
    },
    generatePatientForm() {
      this.$refs.html2PdfPatientForm.generatePdf();
    },
    generateNurseNotesForm() {
      this.$refs.html2PdfNurse.generatePdf();
    },
    async getPatientCard() {
      this.loading = true;
      await this.getPatient(
        `patientCard?filter[patient_id]=${
          this.patientData.id
        }&filter[is_active]=${true}&include[]=patientRoom&include[]=surgeries&sort=-created_at`
      );
      this.loading = false;
      if (this.all_data.data[0]) {
        this.patientCardDetails = this.all_data.data[0];
      }
      if (this.all_data.data.length == 0) {
        this.patientCardDetails = "";
        this.buttonLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
